import { inputClassNames, labelClassNames } from 'components/forms/input';
import { useBasket } from 'lib/hooks/basket/use-basket';

export const NoteSection = () => {
  const [basket, modifyBasket] = useBasket();

  return (
    <>
      <section className=' border-t-2 mt-4  p-4 border rounded-md border-gray-200 w-full'>
        <label htmlFor='customer_note' className={labelClassNames}>
          <span className='font-bold'>
            Special Instructions / Notes for our booksellers
          </span>
          <textarea
            id='customer_note'
            className={inputClassNames}
            value={basket.note}
            onChange={(e) =>
              modifyBasket({
                type: 'add-note',
                payload: e.target.value,
              })
            }
          />
        </label>
      </section>
    </>
  );
};
